import { useEffect, useRef } from 'react';

export default function useGeocodePrefill(formState, setFormState, shouldPrefill = true) {
  const hasPrefilledRef = useRef(false);

  useEffect(() => {
    if (!shouldPrefill || hasPrefilledRef.current) return;

    let cancelled = false;
    let service = null;

    const resolveAddresses = async () => {
      try {
        const mod = await import('@/lib/hybridMappingService');
        service = mod.default;

        // Only prefill once when initial values exist and no selection yet
        const tasks = [];
        if (formState.pickup && !formState.selectedPickup) {
          tasks.push(
            service.geocodeAddress(formState.pickup).then((result) => ({ key: 'selectedPickup', result }))
          );
        }
        if (formState.dropoff && !formState.selectedDropoff) {
          tasks.push(
            service.geocodeAddress(formState.dropoff).then((result) => ({ key: 'selectedDropoff', result }))
          );
        }

        const results = await Promise.allSettled(tasks);
        if (!cancelled) {
          setFormState(prev => {
            const next = { ...prev };
            results.forEach(r => {
              if (r.status === 'fulfilled' && r.value?.result) {
                const { key, result } = r.value;
                next[key] = { lat: result.lat, lng: result.lng, description: key === 'selectedPickup' ? formState.pickup : formState.dropoff };
              }
            });
            return next;
          });
          hasPrefilledRef.current = true;
        }
      } catch (_) {
        // silent fallback
        hasPrefilledRef.current = true;
      }
    };

    resolveAddresses();
    return () => { cancelled = true; };
  }, [formState.pickup, formState.dropoff, formState.selectedPickup, formState.selectedDropoff, setFormState, shouldPrefill]);
}
